<tabs-pds3
    htmlId="tabs-notes"
    [class]="`wk-cm__card-panel__${type()}__notes`"
    srLabel="notes-tabs"
    selectedTabId="Notes"
    (tabSelect)="onTabSelect($event)"
>
    <tablist-pds3>
        <tab-pds3 tabId="Notes">{{ "iFirmTaxNotes.Title" | translate }}</tab-pds3>
        <tab-pds3 tabId="iFirmNotes">{{ title() | translate }}</tab-pds3>
    </tablist-pds3>
    <tab-line-pds3 />
    <tab-panels-pds3>
        <tab-panel-pds3 panelId="Notes">
            <textarea-field-pds3>
                <textarea class="fancy-scrollbar-newUI" [formControl]="cardModalService.cardModalFormGroup().get(field())"></textarea>
            </textarea-field-pds3>
        </tab-panel-pds3>
        <tab-panel-pds3 panelId="iFirmNotes">
            @if (currentTabId() === "iFirmNotes") {
                <ng-content />
            }
        </tab-panel-pds3>
    </tab-panels-pds3>
</tabs-pds3>
